import React, { useState } from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { PlusIcon, XIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="border-b border-[#CCCCCC] py-4" data-id="element-584">
      <button className="w-full flex items-center justify-between text-left py-2 focus:outline-none group min-h-[48px]" onClick={onClick} data-id="element-585">
        <span className="text-black font-bold text-lg font-[Poppins,_sans-serif] pr-8 group-hover:text-[#FF1493] transition-colors" data-id="element-586">
          {question}
        </span>
        <span className="text-[#FF1493] flex-shrink-0 transition-transform duration-300" data-id="element-587">
          {isOpen ? <XIcon size={24} data-id="element-588" /> : <PlusIcon size={24} data-id="element-589" />}
        </span>
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-590">
        <p className="text-[#333333] text-base font-body leading-[1.7] pt-4 pb-2" data-id="element-591">
          {answer}
        </p>
      </div>
    </div>;
}
export function CSFAQ() {
  const [openIndex, setOpenIndex] = useState<number>(0);
  const faqs = [{
    question: 'What Is ClearSilk Laser Rejuvenation?',
    answer: 'ClearSilk laser rejuvenation is an advanced aesthetic procedure that utilizes laser technology to improve skin texture, tone, and pigmentation irregularities. It works by delivering controlled pulses of light energy to the skin, stimulating collagen production and promoting cellular renewal for a smoother, more youthful complexion.'
  }, {
    question: 'What Skin Concerns Can ClearSilk Address?',
    answer: 'ClearSilk laser rejuvenation is effective in treating a variety of skin concerns, including dullness, pigmentation issues, fine lines, wrinkles, acne scars, and uneven skin texture. It can also help improve overall skin tone and reduce the appearance of pores.'
  }, {
    question: 'Is It Suitable For All Skin Types?',
    answer: 'Yes, ClearSilk laser rejuvenation is safe and effective for all skin types, including fair, medium, and dark skin tones. The treatment can be customized to address specific skin concerns while minimizing the risk of adverse effects.'
  }, {
    question: 'Is There Downtime Associated With Laser Rejuvenation?',
    answer: 'One of the benefits of ClearSilk laser rejuvenation is minimal downtime. While some redness and warmth may occur immediately after the treatment, these side effects typically subside within 24 hours. Patients can resume their normal activities immediately following the procedure.'
  }, {
    question: 'How Many Sessions Are Needed?',
    answer: "The number of ClearSilk laser rejuvenation sessions required varies depending on the individual's skin condition and treatment goals. However, most patients typically undergo a series of treatments spaced several weeks apart to achieve optimal results."
  }];
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-592">
      <div className="max-w-[800px] mx-auto px-6 lg:px-8" data-id="element-593">
        <AnimateOnScroll className="text-center flex flex-col items-center mb-12" data-id="element-594">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-black leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-595">
            FREQUENTLY ASKED QUESTIONS
          </h2>
          <div className="w-[40px] h-[2px] bg-[#FF1493]" data-id="element-596"></div>
        </AnimateOnScroll>

        <AnimateOnScroll delay={200} data-id="element-597">
          <div className="space-y-2" data-id="element-598">
            {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? -1 : index)} data-id="element-599" />)}
          </div>
        </AnimateOnScroll>
      </div>
    </section>;
}